/* Contact-page navigation only. Availability and booking stay in the existing Cal.com embed. */
(() => {
  'use strict';
  if (customElements.get('bvj-contact-agenda')) return;
  class BvjContactAgenda extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.page = this.closest('bvj-contact-page');
      const updateVisibility = () => {
        const rect = this.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight;
        this.page?.toggleAttribute('data-contact-booking-visible', visible);
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(updateVisibility);
        this.observer.observe(this);
      } else {
        window.addEventListener('scroll', updateVisibility, { passive: true, signal });
      }
      window.addEventListener('resize', updateVisibility, { passive: true, signal });
      updateVisibility();
      // Legacy links to the former appointment-request form now reach this agenda.
      const url = new URL(location.href);
      if (url.searchParams.get('onderwerp') === 'showroomafspraak' && (!url.hash || url.hash === '#formulier')) {
        url.searchParams.delete('onderwerp');
        url.hash = this.id;
        history.replaceState(history.state, '', url);
        this.frame = requestAnimationFrame(() => {
          this.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
      }
      // Let native anchors navigate; close an open mobile menu through its own summary.
      document.addEventListener('click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest?.('a[href]');
        if (!link || link.target === '_blank') return;
        let destination;
        try { destination = new URL(link.href, location.origin); } catch { return; }
        if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.hash !== '#' + this.id) return;
        const drawer = link.closest('header-drawer');
        const summary = drawer?.querySelector('details[open] > summary');
        if (summary) summary.click();
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.page?.removeAttribute('data-contact-booking-visible');
      this.ready = false;
    }
  }
  customElements.define('bvj-contact-agenda', BvjContactAgenda);
})();
